var _rect, _rect2, _rect3, _path, _path2, _path3, _rect4, _circle, _circle2, _circle3, _circle4, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 823,
    height: 232,
    viewBox: "0 0 823 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 309.518,
    y: 1,
    width: 230,
    height: 230,
    rx: 42.6706,
    fill: "#3568DD",
    stroke: "#191919",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 321.8,
    y: 14.6471,
    width: 204.071,
    height: 204.071,
    rx: 102.035,
    fill: "#457EFF",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2236,
    y: 1,
    width: 230,
    height: 230,
    rx: 42.6706,
    fill: "#E6E6E6",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8701 171.953L65.3904 173.688C90.9055 191.256 124.683 190.991 149.92 173.026L151.428 171.953",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8554 78.43C45.8536 73.274 53.301 73.274 56.2993 78.43L66.7379 96.3806C67.4158 97.5463 68.3852 98.5157 69.5509 99.1936L87.5015 109.632C92.6575 112.63 92.6575 120.078 87.5015 123.076L69.5509 133.515C68.3852 134.193 67.4158 135.162 66.7379 136.328L56.2993 154.278C53.301 159.434 45.8536 159.434 42.8554 154.278L32.4168 136.328C31.7389 135.162 30.7695 134.193 29.6038 133.515L11.6531 123.076C6.49718 120.078 6.49718 112.63 11.6531 109.632L29.6037 99.1936C30.7695 98.5157 31.7389 97.5463 32.4168 96.3806L42.8554 78.43Z",
    fill: "white",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.491 78.43C160.489 73.274 167.937 73.274 170.935 78.43L181.374 96.3806C182.052 97.5463 183.021 98.5157 184.187 99.1936L202.137 109.632C207.293 112.63 207.293 120.078 202.137 123.076L184.187 133.515C183.021 134.193 182.052 135.162 181.374 136.328L170.935 154.278C167.937 159.434 160.489 159.434 157.491 154.278L147.053 136.328C146.375 135.162 145.405 134.193 144.239 133.515L126.289 123.076C121.133 120.078 121.133 112.63 126.289 109.632L144.239 99.1936C145.405 98.5157 146.375 97.5463 147.053 96.3806L157.491 78.43Z",
    fill: "white",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 591.094,
    y: 1,
    width: 230,
    height: 230,
    rx: 42.6706,
    fill: "#E6E6E6",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 657.646,
    cy: 67.5529,
    r: 41.9882,
    fill: "#676B73",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.646,
    cy: 164.447,
    r: 41.9882,
    fill: "#C2C5CC",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.541,
    cy: 67.5529,
    r: 41.9882,
    fill: "#457EFF",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.541,
    cy: 164.447,
    r: 41.9882,
    fill: "white",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M749.428 39.4702C751.625 35.6922 757.082 35.6922 759.279 39.4702L766.928 52.6237C767.425 53.4779 768.135 54.1882 768.989 54.685L782.143 62.3339C785.921 64.531 785.921 69.9881 782.143 72.1851L768.989 79.8341C768.135 80.3308 767.425 81.0411 766.928 81.8953L759.279 95.0488C757.082 98.8269 751.625 98.8269 749.428 95.0488L741.779 81.8953C741.282 81.0411 740.572 80.3308 739.717 79.8341L726.564 72.1851C722.786 69.9881 722.786 64.5309 726.564 62.3339L739.717 54.685C740.572 54.1882 741.282 53.4779 741.779 52.6237L749.428 39.4702Z",
    fill: "#3568DD",
    stroke: "#1D1D1D",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M529.191 8.31014C534.123 -1.4367 546.912 -1.43672 551.844 8.31011L653.874 209.939C658.722 219.519 652.282 231 642.548 231H438.487C428.753 231 422.313 219.519 427.161 209.939L529.191 8.31014Z",
    fill: "#FF7A00",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M530.768 167.426C530.799 168.709 531.848 169.732 533.132 169.732H547.903C549.186 169.732 550.235 168.709 550.267 167.426L552.4 80.5757C552.433 79.2474 551.365 78.153 550.036 78.153H530.998C529.67 78.153 528.602 79.2474 528.634 80.5757L530.768 167.426ZM529.615 200.612C529.615 201.918 530.674 202.976 531.98 202.976H548.885C550.191 202.976 551.25 201.918 551.25 200.612V184.344C551.25 183.038 550.191 181.98 548.885 181.98H531.98C530.674 181.98 529.615 183.038 529.615 184.344V200.612Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M595.902 102.081C596.283 98.7503 600.116 97.0704 602.822 99.0481L609.729 104.095C610.341 104.542 611.058 104.822 611.811 104.908L620.31 105.879C623.64 106.259 625.32 110.093 623.342 112.799L618.295 119.706C617.848 120.317 617.568 121.035 617.482 121.788L616.511 130.287C616.131 133.617 612.298 135.297 609.591 133.319L602.685 128.272C602.073 127.825 601.355 127.545 600.602 127.459L592.104 126.488C588.773 126.108 587.094 122.274 589.071 119.568L594.118 112.662C594.565 112.05 594.846 111.332 594.932 110.579L595.902 102.081Z",
    fill: "#D24D0C",
    stroke: "#0C0C0D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.13aec2b1be8b51c342c7ee77e33325c5.svg";
export { ForwardRef as ReactComponent };